import { ArrowBack } from "@mui/icons-material";
import { List, ListItemButton } from "@mui/material";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { accountDelationFn } from "../../../Services/AccountDelation";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../Redux/Actions/SnackBar";

const AccountDeletion = () => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const dispatch = useDispatch();
  const { mutate: deleteAccount } = useMutation(accountDelationFn, {
    onSuccess: (res) => {
      localStorage.clear();
      navigate("/");
      dispatch(
        setSnackbar({
          open: true,
          message: res.data.message,
          variant: "success",
        })
      );
      client.refetchQueries("cartList");
      client.refetchQueries("myWishList");
    },
  });
  return (
    <>
      <div className="fixed h-16 z-50 flex items-center gap-5 bg-white dark:bg-zinc-900 py-4 px-2 shadow w-full">
        <ArrowBack onClick={() => navigate(-1)} />
        <p className="font-semibold text-lg">Account Deletion</p>
      </div>
      <div className="py-[60px]">
        <List>
          <ListItemButton onClick={() => deleteAccount()}>
            Delete Your Account
          </ListItemButton>
        </List>
      </div>
    </>
  );
};

export default AccountDeletion;
